import { render, staticRenderFns } from "./BSMQuantity.vue?vue&type=template&id=5361f209&scoped=true"
import script from "./BSMQuantity.vue?vue&type=script&lang=js"
export * from "./BSMQuantity.vue?vue&type=script&lang=js"
import style0 from "./BSMQuantity.vue?vue&type=style&index=0&id=5361f209&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5361f209",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
